<template>
  <b-modal id="new-members" size="sm" title="Add Card Numbers">
    <div id="add-new-members" class="modal-form">
      <b-form-file
        v-model="form.file"
        ref="file-input"
        placeholder="Choose a file..."
        accept=".csv"
        drop-placeholder="Drop file here..."
        class="mb-1"
      ></b-form-file>
      <b-link href="https://s3.ap-southeast-1.amazonaws.com/rush-revamp.loyaltyco.xyz/production/purchase-package/import_cards_format.csv" class="mb-0">CSV (Sample)</b-link>
    </div>
    <div slot="modal-footer">
      <b-button
        variant="ghost"
        v-bind:disabled="loading"
        class="btn-cancel"
        style="margin-right: .25rem;"
        @click="clearFields"
      >Cancel</b-button>
      <b-button
        variant="primary"
        v-bind:disabled="loading"
        style="margin-left: .25rem;"
        @click="sendForm"
      >
        <template v-if="loading">Saving...</template>
        <template v-else>Save</template>
      </b-button>
    </div>
  </b-modal>
</template>
<script>
import { mapState } from "vuex";
import notification from "@/services/notification";

function initialState() {
  return {
    form: {
      file: null
    }
  };
}
export default {
  name: "add-members",
  props: ["purchasePackageUuid"],
  data() {
    return initialState();
  },
  computed: {
    ...mapState("purchasePackages", ["loading", "errors"])
  },
  methods: {
    async sendForm() {
      this.$store.dispatch("purchasePackages/resetErrors");

      const fileInBase64 = this.form.file
        ? await this.getBase64(this.form.file)
        : null;

      let param = {
        csv: fileInBase64
          ? fileInBase64.split("base64,").pop()
          : null,
        package_uuid: this.purchasePackageUuid
      };
      
      if (!this.form.file) {
        notification.warning('No file chosen');
      } else if (this.form.file.size > 2097152) {
        notification.warning('This file can\'t be uploaded, because it (' + this.formatBytes(this.form.file.size) + ') exceeds the maximum  upload size (2MB) for this site.');
      } else {
        let _this = this;
        await this.$store
          .dispatch("purchasePackages/importCardNos", param)
          .then(function() {
            if (_this.errors == null) {
              _this.clearFields();
              _this.hideModal("new-members");
              _this.getPurchasePackages(1);
              _this.getTopPurchasePackages();
            }
          });
      }
    },
    clearFields() {
      let initialData = initialState();

      // Iterate through the props
      for (let prop in initialData) {
        // Reset the prop locally.
        this[prop] = initialData[prop];
      }

      this.$refs['file-input'].reset();

      this.hideModal("new-members");
      this.$store.dispatch("purchasePackages/resetErrors");
    },
    async getPurchasePackages(page) {
      let param = {
        page: page,
        payload: this.searchPayload
      };
      await this.$store.dispatch("purchasePackages/getPurchasePackages", param);
    },
    async getTopPurchasePackages() {
      await this.$store.dispatch("purchasePackages/getTopPurchasePackages");
    },
    showModal(modal) {
      this.$root.$emit("bv::show::modal", modal);
    },
    hideModal(modal) {
      this.$root.$emit("bv::hide::modal", modal);
    },
    async getBase64(file, onLoadCallback) {
      return new Promise(function(resolve, reject) {
        const reader = new FileReader();
        reader.onload = function() {
          resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },
    formatBytes(bytes) {
      if(bytes < 1024) return bytes + " Bytes";
      else if(bytes < 1048576) return(bytes / 1024).toFixed(3) + " KB";
      else if(bytes < 1073741824) return(bytes / 1048576).toFixed(3) + " MB";
      else return(bytes / 1073741824).toFixed(3) + " GB";
    }
  }
};
</script>